import dynamic from 'next/dynamic';
import css from './index.module.scss';
import EFVideo from '@/components/UI/EFVideo';
import PDFActivity from 'elem/compCommon/PillarPageActivities/PDFActivity';
import QuoteWinFloat from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWinFloat';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import EcoImg from 'eco-design/base/eco-img';

const videoMap: any = {
    us: ['/video/deltapro/kv.webm', '/video/deltapro/kv.mp4'],
    au: ['/video/deltapro/kv_au.webm', '/video/deltapro/kv_au.mp4'],
    uk: ['/video/deltapro/kv_uk.webm', '/video/deltapro/kv_uk.mp4'],
    jp: ['/video/deltapro/kv_jp.webm', '/video/deltapro/kv_jp.mp4'],
    fr: ['/video/deltapro/kv_eu.webm', '/video/deltapro/kv_eu.mp4'],
    de: ['/video/deltapro/kv_eu.webm', '/video/deltapro/kv_eu.mp4'],
    cn: ['/video/deltapro/kv_cn.webm', '/video/deltapro/kv_cn.mp4'],
    es: ['/video/deltapro/kv_eu.webm', '/video/deltapro/kv_eu.mp4'],
    eu: ['/video/deltapro/kv_eu.webm', '/video/deltapro/kv_eu.mp4'],
    it: ['/video/deltapro/kv_eu.webm', '/video/deltapro/kv_eu.mp4'],
    cis: ['/video/deltapro/kv_eu.webm', '/video/deltapro/kv_eu.mp4'],
    za: ['/video/deltapro/kv_za.webm', '/video/deltapro/kv_za.mp4'],
    sa: ['/video/deltapro/kv_uk.webm', '/video/deltapro/kv_uk.mp4'],
    kr: ['/video/deltapro/kv_eu.webm', '/video/deltapro/kv_eu.mp4'],
    ph: 'https://websiteoss.ecoflow.com/upload/image/1751273616191/kv.jpg',
};

const PageConPc = dynamic(() => import('@/components/ProductDelta/deltapronew/indexDynamic'), {
    ssr: true,
});

export default function Page() {
    const { locale, query } = useRouter();
    const [isClient, setIsClient] = useState(false);
    const [openQuoteFlag, setOpenQuoteFlag] = useState(false);
    const now = query?._timer ? new Date(query?._timer).getTime() : new Date().getTime();
    const times = {
        us: '2024/09/23 15:00:00 GMT+8',
    };
    const IS_ACTIVE = now >= new Date(times[locale]).getTime();

    const quoteCallback = (type: string) => {
        if (type === 'close') {
            setOpenQuoteFlag(false);
        } else if (type === 'open') {
            setOpenQuoteFlag(true);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <div className={`${css.gsapa} gsapa`}>
            <div className="blockWrapper">
                <div className="section1 GtmModuleData-section" data-section-id={'section1'} data-section-title={'Banner'}>
                    {/* 首屏kv */}
                    <div className="videoWrapper">
                        {locale === 'ph' ? <EcoImg pc={videoMap[locale]} /> : <EFVideo loop={false} sources={videoMap[locale as 'us'] || videoMap.us} />}
                    </div>
                </div>
            </div>
            {locale === 'us' && !IS_ACTIVE && <PDFActivity />}
            <PageConPc />
            {locale === 'us' && isClient && <QuoteWinFloat callback={quoteCallback} />}
            {locale === 'us' && isClient && openQuoteFlag && <QuoteWin callback={quoteCallback} />}
        </div>
    );
}
